import { render, staticRenderFns } from "./AddressCreateUpdate2.vue?vue&type=template&id=c30cea24&scoped=true&"
import script from "./AddressCreateUpdate2.vue?vue&type=script&lang=js&"
export * from "./AddressCreateUpdate2.vue?vue&type=script&lang=js&"
import style0 from "./AddressCreateUpdate2.vue?vue&type=style&index=0&id=c30cea24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30cea24",
  null
  
)

export default component.exports